import { render, staticRenderFns } from "./CommunicationLog.vue?vue&type=template&id=6258efcf&scoped=true&"
import script from "./CommunicationLog.vue?vue&type=script&lang=js&"
export * from "./CommunicationLog.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationLog.vue?vue&type=style&index=0&id=6258efcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6258efcf",
  null
  
)

export default component.exports